import { IonButton, IonContent, IonIcon, IonLoading, IonPopover, IonText } from "@ionic/react"
import { useEffect, useState } from "react"
import { useParams } from "react-router"
import { API_URL } from "../../actions/settings"
import EstarHeader from "../../components/Energystar/EstarHeader"
import './Meter.css'
import { menuOutline } from "ionicons/icons"
import EstarBills from "../../components/Energystar/EstarBills"
import { isStaff } from "../../components/extras/Functions"
import { useSelector } from "react-redux"
import { selectUser } from "../../reducers/UserReducer"
import CheckRole from "../../components/extras/CheckRole"
import useToggle from "../../utils/useToggle"
import NotificationPopUp from "../../components/extras/NotificationPopUp"

interface Params {
    meterId:string
}

async function getMeter(token:any,id:any) {

    return fetch(`${API_URL}/energystar/meters/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization':token
      }

    })
      .then(data => data.json())
   }
async function toggleCostAvoidance(token:any,id:any) {

    return fetch(`${API_URL}/energystar/meters/${id}/toggle_cost_avoidance`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization':token
      }

    })
      .then((res) => {
        if (res.ok) {
          NotificationPopUp('success',"Cost Avoidance Enabled/Disabled")
        }
        else{
            console.log('error')
            res.json().then( err => {
                NotificationPopUp("Error", err, "Error Toggling Cost Avoidance ")
                // throw error here to use the catch
            })

        }
      })
   }


const Meter: React.FC = ()=>{

    const { meterId } = useParams<Params>();
    const [open,toggleOpen] = useToggle(false)
    const [ meter, setMeter ] = useState<any>({})
    const [ loaded, setLoaded ] = useState<boolean>(false)
    const user = useSelector(selectUser)


    const handleMeter = async (id:any) => {
        const token = localStorage.getItem('token') || ""
        const res = await getMeter(`Token ${token.slice(1,-1)}`,id)
        setMeter(res.data)
        setLoaded(true)

    }

    const handleToggleCostAvoidance = async (id:any) => {
        const token = localStorage.getItem('token') || ""
        await toggleCostAvoidance(`Token ${token.slice(1,-1)}`,id)
        handleMeter(id)

    }

    const getDate = (fullDate:any) =>{
        const date = new Date(fullDate)

        const string = `${date.getMonth()}-${date.getDate()}-${date.getFullYear()}`
        return string
    }

    useEffect(()=>{
        handleMeter(meterId)
    }, [meterId])
    useEffect(()=>{
        if (Object.keys(meter).length !== 0){
            setLoaded(true)
        }
    }, [meter])


    const copyUUID = () => {
    navigator.clipboard.writeText(meter.id);
    const popup = document.getElementById("copied");
    popup?.classList.toggle("show");
    setTimeout(() => {
      const popup = document.getElementById("copied");
      popup?.classList.toggle("show");
    }, 3000);
  };

    return (
        <IonContent>
            {!loaded ?
            <IonLoading
                cssClass='my-custom-class'
                isOpen={!loaded}
                message={'Loading...'}
                spinner='bubbles'
                /> :
                <>
            <EstarHeader/>
            <IonContent className="estar-meter ion-justify-content-center">
                <div style={{margin:'10px'}}>
                    <div style={{display:'flex'}}>
                        <h1 style={{verticalAlign:'middle'}}>{meter.name} {meter.inuse ? '': `(Inactive:${getDate(meter.inactivedate)})`}</h1>                        
                        {isStaff(user) ? (
                                      <>
                                        <span className="popup">
                                          <span className="popuptext" id="copied">
                                            Copied
                                          </span>                                          
                                        </span>
                                        <IonButton
                                                hidden={!CheckRole(user, ["Admin", "Supervisor"])}
                                                id="meter-btns"
                                                fill="clear"
                                                color="light"
                                                slot="icon-only"
                                                >
                                                <IonIcon slot="icon-only" src={menuOutline}></IonIcon>
                                            </IonButton>
                                      </>
                                    ) : (
                                      ""
                                    )}
                        
                                    <IonPopover
                                      trigger="meter-btns"
                                      size="auto"
                                      side="right"
                                      alignment="start"
                                      showBackdrop={false}
                                    >
                                      <IonContent>
                                        <IonButton
                                          color="dark"
                                          fill="clear"
                                          expand="full"
                                            href={`/energystar/meters/${meterId}/edit`}
                                        >
                                          Edit Meter
                                        </IonButton>
                                        <IonButton
                                            className="clipboardButton"
                                            color="dark"
                                            fill="clear"
                                            expand="full"
                                            onClick={copyUUID}
                                        >
                                            {/* <IonIcon md={copy} ios={copyOutline} /> */}
                                            COPY ID
                                          </IonButton>
                                        
                                        <IonButton
                                          color="dark"
                                          fill="clear"
                                          expand="full"
                                            href={`/energystar/meters/${meter.id}/bills`}
                                        >
                                          Add Bills
                                        </IonButton>
                                        <IonButton
                                          color="dark"
                                          fill="clear"
                                          expand="full"
                                          onClick={()=>handleToggleCostAvoidance(meter.id)}
                                        >
                                          {meter.baseline_adjustment_method.name === "Disabled" ? "Enable " : "Disable "}
                                          Cost Avoidance
                                        </IonButton>
                                      </IonContent>
                                    </IonPopover>
                    </div>
                    <div>
                        (<a style={{color:'white'}} href={`/energystar/properties/${meter.property.id}`}>{meter.property.name}</a>)
                    </div>
                </div>

                
                <div className="collapsable-box">
                    <div className="collapsable-box-header" onClick={toggleOpen}>
                        <span style={{paddingRight:'10px'}}>{open ?  '▼' : '▶'}</span>
                        <div>Basic Meter Info</div>
                        
                    </div>
                    <div className={`collapsable-box-content ${open ? 'open' : ''}`}>
                        <IonText className="meter-info">
                            <ul>
                                <li>Energy Star ID: {meter.meter_id}</li>
                                <li>Type of Meter: {meter.type.name}</li>
                                <li>Date of First Bill: {getDate(meter.firstbilldate)}</li>
                                <li>Metered: {meter.metered ? "Yes": "No"}</li>
                                <li>Currently In Use: {meter.inuse ? "Yes":"No"}</li>
                                {meter.inuse ? "": <li> Inactive Date: {getDate(meter.inactivedate)}</li>}
                            </ul>

                        </IonText>  
                    </div>
                </div>

                
                <div className="Bills">
                    <EstarBills id={meterId} name={meter.name} data={meter.bills} type={meter.type} />
                </div>

            </IonContent></>
        }

        </IonContent>
    )

}

export default Meter